import Helmet from 'react-helmet';

export const getFaviconUrl = (width = 32, format = 'png') => {
  return `https://cloudinary-res.cloudinary.com/image/upload/f_auto,q_auto/c_scale,w_${width}/website/cloudinary_web_favicon.${format}`;
};

export const CloudinaryFavicon = () => {
  return (
    <Helmet>
      <link href={getFaviconUrl(192)} rel="icon" sizes="192x192" type="image/png" />
      <link href={getFaviconUrl(96)} rel="icon" sizes="96x96" type="image/png" />
      <link href={getFaviconUrl(32)} rel="icon" sizes="32x32" type="image/png" />
      <meta content="#3846C0" name="msapplication-TileColor" />
      <meta content={getFaviconUrl(144)} name="msapplication-TileImage" />
      <link href={getFaviconUrl(180)} rel="apple-touch-icon" />
    </Helmet>
  );
};
